(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("next-core-structures"));
	else if(typeof define === 'function' && define.amd)
		define("presentation-storage", ["next-core-structures"], factory);
	else if(typeof exports === 'object')
		exports["presentation-storage"] = factory(require("next-core-structures"));
	else
		root["presentation-storage"] = factory(root["next-core-structures"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 